module.exports = __webpack_public_path__ + "static/media/product_21.f5e3fdaa.png";